package com.patronat.top.ui.molecules.schedule

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.atoms.AppSwitch
import com.patronat.top.ui.molecules.inputs.TimeInputField
import com.patronat.top.ui.models.WorkScheduleDay
import com.patronat.top.ui.theme.MineShaft900
import com.patronat.top.ui.theme.VenueScheduleDayOffText
import com.patronat.top.ui.theme.VenueScheduleText
import com.patronat.top.ui.theme.VenueScheduleTimeInputText

@Composable
fun WorkScheduleDayRow(
    day: WorkScheduleDay,
    onDayChange: (WorkScheduleDay) -> Unit,
    modifier: Modifier = Modifier,
    timePlaceholder: String = "hh:mm",
    timeSeparator: String = "-",
    timeFieldWidth: Dp = 138.dp,
    dayLabelWidth: Dp = 108.dp,
    dayOffLabel: String = "Вихідний"
) {
    Row(
        modifier = modifier.fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            text = day.label,
            style = VenueScheduleText,
            color = MineShaft900,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis,
            modifier = Modifier.width(dayLabelWidth)
        )

        Spacer(modifier = Modifier.width(8.dp))

        if (day.isOpen) {
            TimeInputField(
                value = day.openTime,
                onValueChange = { onDayChange(day.copy(openTime = it)) },
                enabled = true,
                placeholder = timePlaceholder,
                textStyle = VenueScheduleTimeInputText,
                placeholderTextStyle = VenueScheduleTimeInputText,
                fieldHeight = 38.dp,
                modifier = Modifier.width(timeFieldWidth)
            )

            Spacer(modifier = Modifier.width(9.dp))

            Text(
                text = timeSeparator,
                style = VenueScheduleText,
                color = MineShaft900
            )

            Spacer(modifier = Modifier.width(9.dp))

            TimeInputField(
                value = day.closeTime,
                onValueChange = { onDayChange(day.copy(closeTime = it)) },
                enabled = true,
                placeholder = timePlaceholder,
                textStyle = VenueScheduleTimeInputText,
                placeholderTextStyle = VenueScheduleTimeInputText,
                fieldHeight = 38.dp,
                modifier = Modifier.width(timeFieldWidth)
            )
        } else {
            Box(
                modifier = Modifier
                    .height(38.dp)
                    .width(timeFieldWidth),
                contentAlignment = Alignment.CenterStart
            ) {
                Text(
                    text = dayOffLabel,
                    style = VenueScheduleDayOffText,
                    color = MineShaft900
                )
            }
        }

        Spacer(modifier = Modifier.weight(1f))

        AppSwitch(
            checked = day.isOpen,
            onCheckedChange = { onDayChange(day.copy(isOpen = it)) }
        )
    }
}
